import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { yupResolver } from '@hookform/resolvers/yup';
import { Box, TextField, Card, CardContent, Typography } from '@mui/material';

import { PrimaryButton } from 'src/components/common/buttons/PrimaryButton';
import { selectIsLoading } from 'src/components/common/loading/loadingSlice';
import { ILoginCredentials } from 'src/features/auth/domain/types';
import { ISignInFormProps } from 'src/features/auth/domain/types';
import { SignInFormValidationSchema } from 'src/features/auth/domain/validation';

import { PasswordVisibilityIcon } from './PasswordVisibilityIcon';

export const SignInForm: React.FC<ISignInFormProps> = ({ onSubmit }) => {
	const isLoading = useSelector(selectIsLoading);
	const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<ILoginCredentials>({
		resolver: yupResolver(SignInFormValidationSchema),
	});

	return (
		<Box className='flex flex-col max-w-2xl p-6 m-auto justify-center h-[100vh]'>
			<Card className='p-6 drop-shadow-lg rounded'>
				<CardContent>
					<Typography
						align='center'
						color='#000000'
						sx={{ fontSize: '24px' }}
					>
						Sign In
					</Typography>
					<form
						onSubmit={handleSubmit(onSubmit)}
						style={{ marginTop: '30px' }}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								gap: 2,
							}}
						>
							<Controller
								name='email'
								control={control}
								defaultValue=''
								render={({ field }) => (
									<TextField
										label='Email'
										fullWidth
										size='medium'
										{...field}
										error={!!errors?.email}
										helperText={errors?.email?.message}
									/>
								)}
							/>
							<Controller
								name='password'
								control={control}
								defaultValue=''
								render={({ field }) => (
									<TextField
										fullWidth
										label='Password'
										type={
											passwordVisible
												? 'text'
												: 'password'
										}
										{...field}
										error={!!errors?.password}
										helperText={errors?.password?.message}
										size='medium'
										InputProps={{
											endAdornment: (
												<PasswordVisibilityIcon
													handleToggle={() =>
														setPasswordVisible(
															(flag) => !flag,
														)
													}
													visibility={passwordVisible}
												/>
											),
										}}
									/>
								)}
							/>
							<PrimaryButton isLoading={isLoading}>
								SIGN IN
							</PrimaryButton>
						</Box>
					</form>
				</CardContent>
			</Card>
		</Box>
	);
};
